// extracted by mini-css-extract-plugin
export default {"list":"items-list-module_list-VimKs","empty":"items-list-module_empty-fSpwN","observer":"items-list-module_observer-EtUFj"};